<div class="simple-tile">
  <mat-grid-list [cols]="secondaryType=='PERCENTAGE' ? 5 : 3" rowHeight="fit" style="height:100%">
    <mat-grid-tile  *ngIf="secondaryType=='PERCENTAGE'" colspan="2">
      <ngx-gauge type="full"
        [value]="_secondaryValue"
        duration="750"
        size="80"
        thick="7"
        append="%"
        [foregroundColor]="themeService.themeColors.primary"
        [backgroundColor]="themeService.themeColors.accent">
      </ngx-gauge>

    </mat-grid-tile>
    <mat-grid-tile colspan="3">
      <div>
        <div style="font-size:2em;">{{_primaryValue}}</div>
        <div [matTooltip]="labelToolTip" matTooltipPosition="right">{{label}} <sup *ngIf="labelToolTip" style="display:inline-block; cursor: help">?</sup></div>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</div>
